import fetch, { doGet, doPost } from '../../tools/axios'

export default {
  getShipsnPic (id, cb) {
    return fetch('get', `/ship/printFami?shipsn=${id}`, {}, cb)
  },
  getDealsCategory (cb) {
    return fetch('get', '/my/category', {}, cb)
  },
  getMyDemands (page, type, status, cb) {
    const query = (type ? `&type=${type}` : '') +
      (status ? `&status=${status}` : '')
    const url = `/my/myDemands?perPage=15&page=${page}${query}`
    return fetch('get', url, {}, cb)
  },
  getDemandTotal (type, status, cb) {
    const query = (type ? `type=${type}` : '') +
      (status ? `&status=${status}` : '')
    return fetch('get', `/my/demandTotal?${query}`, {}, cb)
  },
  getMyDonates (page, type, status, cb) {
    const query = (type ? `&type=${type}` : '') +
      (status ? `&status=${status}` : '')
    const url = (!type && status === 'init') ? `/my/gift/requesting?perPage=15&page=${page}`
      : `/my/myPresent?perPage=15&page=${page}${query}`
    return fetch('get', url, {}, cb)
  },
  getDonateTotal (type, status, cb) {
    const query = (type ? `type=${type}` : '') +
      (status ? `&status=${status}` : '')
    return fetch('get', `/my/presentTotal?${query}`, {}, cb)
  },
  getConversationId (id, tab, type, dirUserId, cb) {
    const url = `/conversations?id=${id}&tab=${tab}&type=${type}&direct_user_id=${dirUserId}`
    return fetch('get', url, {}, cb)
  },
  dealMerge (ids, type, cb) {
    const url = type === 'gift' ? '/giftRequest/merge' : '/need_donate/merge'
    let data = type === 'gift' ? { gift_request_ids: ids } : { need_donate_ids: ids }
    return fetch('post', url, {data}, cb)
  },
  getMergeList (page, perPage, cb) {
    const url = `/giftRequest/mergeList?perPage=${perPage}&page=${page}`
    return fetch('get', url, {}, cb)
  },
  processMerge (giftRequestId, status, mergeRejectedReason, cb) {
    const url = `/gifts/process`
    return fetch('post', url, {data: {
      gift_request_id: giftRequestId, status, merge_rejected_reason: mergeRejectedReason
    }}, cb)
  },
  getPalmBoxNotTakeOrders () {
    return doGet('/my/palmNotTakeOrders')
  },
  applyCancelDeal (type, objectId, reason, image) {
    return doPost('/apply_cancel_deal', {
      type,
      [`${type}_id`]: objectId,
      reason,
      image
    })
  },
  searchMyDemand (page, type, status, shipway, shipsn) {
    return doGet('/my/myDemands', {
      type,
      status,
      shipway,
      shipsn,
      page
    })
  },
  getMergeableGiftRequestList (giftRequestId, page = 1, perPage = 10) {
    return doGet(`/giftRequests/${giftRequestId}/mergeableList?page=${page}&perPage=${perPage}`)
  },
  getMergeableNeedDonateList (needDonateId, page = 1, perPage = 10) {
    return doGet(`/needDonate/${needDonateId}/mergeableList?page=${page}&perPage=${perPage}`)
  },
  walletPayDeal (dealType, dealId, passcode, couponRecordId = null) {
    return doPost('/wallet/pay', {
      deal_type: dealType,
      deal_id: dealId,
      pass_code: passcode,
      coupon_record_id: couponRecordId
    })
  },
  setRequestWaittingTime (giftRequestId, waitHours) {
    return doPost(`/giftRequests/${giftRequestId}/lock`, {
      lock_hour: waitHours
    })
  },
  canPayDeal (dealType, dealId, shipfee = null) {
    return doGet(`/wallet/canPayDeal?deal_type=${dealType}&deal_id=${dealId}${shipfee ? ('shipfee=' + shipfee) : ''}`)
  },
  getMyUnpaidDeals () {
    return doGet('/my/unpaidDeals')
  },
  getFamiShipRoutes (shipsn) {
    return doGet(`/ship/routes?shipsn=${shipsn}`)
  },
  switchFamiStore (shipsn, storeId) {
    return doPost('/ship/switchStore', { shipsn, store_id: storeId })
  },
  getGiftRequestInfo (id) {
    return doGet(`/giftRequest/${id}`)
  },
  getNeedDonateInfo (id) {
    return doGet(`/needDonate/${id}`)
  },
  remindGiftRequest (id) {
    return doPost(`/gift_requests/${id}/remind`, {})
  },
  remindNeedDonate (id) {
    return doPost(`/need_donates/${id}/remind`, {})
  },
  editDealAddress (dealType, dealId, data) {
    return doPost(`/${dealType}s/${dealId}/edit-address`, data)
  },
  getHilifeShipRoutes (shipsn) {
    return doGet(`/ship/hilife/routes?shipsn=${shipsn}`)
  },
  switchHilifeStore (shipsn, storeId) {
    return doPost('/ship/hilife/switchStore', { shipsn, store_id: storeId })
  },
  getSevenElevenShipRoutes (shipsn) {
    return doGet(`/ship/seveneleven/routes?shipsn=${shipsn}`)
  },
  switchSevenElevenStore (shipsn, storeId) {
    return doPost('/ship/seveneleven/switchStore', { shipsn, store_id: storeId })
  }
}
